import React, { Component } from "react";

import FieldPreview from "./FieldPreview";

import FieldCheckbox from "./FieldCheckbox";
import FieldFile from "./FieldFile";
import FieldRadio from "./FieldRadio";
import FieldRepeater from "./FieldRepeater";
import FieldSelect from "./FieldSelect";
import FieldTable from "./FieldTable";
import FieldText from "./FieldText";
import FieldTextarea from "./FieldTextarea";

import _ from "lodash";

const FieldTypes = {
  textarea: FieldTextarea,
  select: FieldSelect,
  checkboxes: FieldCheckbox,
  radio: FieldRadio,
  file: FieldFile,
  text: FieldText,
  repeater: FieldRepeater,
  table: FieldTable,
  email: FieldText,
  number: FieldText,
  date: FieldText,
  string: FieldText,
  uri: FieldText,
  hidden: FieldText
};

let getFieldType = (schema, uiSchema = {}) => {
  let fieldType = "text";

  if (schema.type === "string") {
    fieldType = "text";
  } else if (schema.type === "number") {
    fieldType = "number";
  } else if (schema.type === "boolean") {
    fieldType = "checkbox";
  }
  if ("enum" in schema) {
    fieldType = "select";
  }
  if ("ui:widget" in uiSchema && uiSchema["ui:widget"] !== "") {
    fieldType = uiSchema["ui:widget"];
  }
  if (schema.type === "array" && "items" in schema) {
    fieldType = "repeater";
  }
  if (
    schema.type === "array" &&
    "items" in schema &&
    uiSchema["ui:widget"] === "table"
  ) {
    fieldType = "table";
  }

  return fieldType;
};

class Field extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldType: getFieldType(props.schema, props.uiSchema),
      showLabel: props.showLabel === false ? false : true,
      value: props.value,
      values: props.values
    };

    this.dummy = this.dummy.bind(this);
    this.labelRef = null;
  }

  componentWillReceiveProps(nextProps) {
    if (
      !_.isEqual(this.state.value, nextProps.value) ||
      !_.isEqual(this.state.values, nextProps.values) ||
      !_.isEqual(this.state.schema, nextProps.schema)
    ) {
      this.setState({
        value: nextProps.value,
        values: nextProps.values,
        schema: nextProps.schema
      });
    }
  }

  dummy(a, b, c) {
    console.log("dummy", a, b, c);
  }

  shouldDisplayField(schema, values) {
    if (!schema) return false;

    if ("conditional" in schema) {
      let conditionalId = Object.keys(schema.conditional)[0];
      let conditionalValue = schema.conditional[conditionalId];
      return (
        _.isMatch(values, schema.conditional) ||
        (conditionalId in values &&
          values[conditionalId].includes(conditionalValue))
      );
    }

    return true;
  }

  componentDidUpdate(prevProps, prevState) {
    let prevDisplay = this.shouldDisplayField(
      prevState.schema,
      prevState.values
    );

    let currDisplay = this.shouldDisplayField(
      this.state.schema,
      this.state.values
    );

    if (
      prevDisplay === false &&
      currDisplay === true &&
      this.state.schema.conditional &&
      !this.state.value &&
      Object.keys(prevState.values).length > 0 &&
      Object.keys(this.state.values).length > 0
    ) {
      this.labelRef.focus();
    }
  }

  render() {
    let {
      id,
      orientation,
      schema,
      subID,
      uiSchema = {},
      ...props
    } = this.props;
    let { value } = this.state;
    let filename,
      inputClass = "",
      labelClass = "",
      groupClass = "";

    if (orientation === "horizontal") {
      groupClass = "row";
      labelClass = "col-md-3";
      inputClass = "col-md-9";
    }

    if ("ui:options" in uiSchema && "labelClass" in uiSchema["ui:options"]) {
      labelClass = `${labelClass} ${uiSchema["ui:options"].labelClass}`;
    }

    if (schema.type === "array") {
      value = Array.isArray(value) ? value : [];

      if (schema.minItems > 0 && _.isEmpty(value)) {
        value.push({});
      }
    }

    // if (this.state.fieldType === "number" && !_.isNumber(value)) {
    //   value = " ";
    // }
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    let fieldType = this.state.fieldType;
    if (isIE11 && this.state.fieldType === "number") {
      fieldType = "text";
    }

    let fieldConfig = {
      autoComplete: "off",
      className:
        id in props.errors ? "form-control is-invalid" : "form-control",
      id: id,
      name: id,
      onBlur: props.handleBlur,
      onChange: props.handleChange,
      onInput: props.handleChange,
      onSubmit: props.handleSubmit,
      type: fieldType,
      value:
        _.isNull(value) || _.isNaN(value) || _.isUndefined(value) ? "" : value
    };

    let counterEl = null;

    // Build character counter
    if ("maxLength" in schema) {
      fieldConfig.maxLength = schema.maxLength;
      if ("characterCount" in uiSchema && !("preview" in props)) {
        counterEl = (
          <p className="counter text-right text-muted">
            {typeof this.state.value === "string"
              ? this.state.value.length
              : "0"}{" "}
            / {schema.maxLength} characters
          </p>
        );
      }
    }

    if ("minimum" in schema) {
      fieldConfig["min"] = schema.minimum;
    }
    if ("maximum" in schema) {
      fieldConfig["max"] = schema.maximum;
    }

    let FieldType = FieldTypes[this.state.fieldType];
    let fieldEl = (
      <FieldType
        fieldConfig={fieldConfig}
        errors={props.errors}
        schema={schema}
        setFieldValue={props.setFieldValue}
        subID={subID}
        uiSchema={uiSchema}
      />
    );

    if (props.preview) {
      let value = this.state.value;

      fieldEl = (
        <FieldPreview
          fieldType={this.state.fieldType}
          filename={filename}
          value={value}
          values={this.state.values}
          {...this.props}
        />
      );
    }

    if ("ui:widget" in uiSchema) {
      groupClass = `${groupClass} widget-${uiSchema["ui:widget"]}`;
    }

    let title = props.required ? schema.title + "*" : schema.title;
    let description = schema.description ? schema.description : "";
    if (description === 0 || description === "0") {
      description = "<br />";
    }
    
    function createMarkup(content) {
      return { __html: content };
    }

    return (
      this.shouldDisplayField(schema, this.state.values) && (
        <div className={`form-group ${groupClass}`} key={id} id={id + "_group"}>
          {this.state.showLabel && (
            <label
              htmlFor={id}
              id={id + "_label"}
              className={labelClass}
              ref={label => {
                this.labelRef = label;
              }}
              dangerouslySetInnerHTML={createMarkup(title)}
            />
          )}
          {(
            <aside
              dangerouslySetInnerHTML={createMarkup(description)}>
            </aside>
          )}
          <div className={inputClass}>
            {fieldEl} {counterEl}{" "}
            {!props.preview && "ui:help" in uiSchema && (
              <small className="form-text text-muted">
                {uiSchema["ui:help"]}
              </small>
            )}
          </div>
        </div>
      )
    );
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/Field.js